import { GridColDef } from "@mui/x-data-grid";

export const getPickerTableColumns = (type: "pickerStats"): GridColDef[] => {
  return [
    { field: "userId", headerName: "Name" },
    { field: "ordersPickedPerHour", headerName: "Orders Picked /hr", disableColumnMenu: true },
    { field: "totalOrdersPicked", headerName: "Total Orders Picked", disableColumnMenu: true },
    { field: "totalPoints", headerName: "Total Points", disableColumnMenu: true },
  ];
};

export const getProcessorTableColumns = (type: "processorStats"): GridColDef[] => {
  return [
    { field: "userId", headerName: "Name" },
    { field: "ordersProcessedPerHour", headerName: "Orders Processed /hr", disableColumnMenu: true },
    { field: "totalOrderProcessed", headerName: "Total Orders Processed", disableColumnMenu: true },
    { field: "totalPoints", headerName: "Total Points", disableColumnMenu: true },
  ];
};
